import { getAllUsersSaga } from './getAllUsers'
import { getDisabledUsersSaga } from './getDisabledUsers'
import { getUserSaga } from './getUser'
import { addUserSaga } from './addUser'
import { deleteAgentSaga } from './deleteAgent'
import { addAgentSaga } from './addAgent'
import { editAgentSaga } from './editAgent'
import { editUserSaga } from './editUser'
import { changeActualPasswordSaga } from './changeActualPassword'
import { changePasswordSaga } from './changePassword'
import { resetPasswordSaga } from './resetPassword'
import { editCitoyenSaga } from './editCitoyen'

const userSagas = [
    getAllUsersSaga,
    getDisabledUsersSaga,
    getUserSaga,
    addUserSaga,
    deleteAgentSaga,
    addAgentSaga,
    editAgentSaga,
    editUserSaga,
    changeActualPasswordSaga,
    changePasswordSaga,
    resetPasswordSaga,
    editCitoyenSaga,
]

export default userSagas
